export const IMAGES = 27;

